<template>
    <!-- TODO css -->
    <modal @close="close">
        <h3 v-if="type === 'edit'">{{ item.name }}</h3>
        <h3 v-else-if="type === 'create'">Create New Option</h3>
        <div class="large-form" style="text-align: left;">

            <div class="form-line" v-if="item.type=='physical'">
                <div class="form-field" style="width: 100%">
                    <label>Linked Product</label>
                    <div class="form-static-field"><router-link :to="'/campaigns/corporate-products/' + item.product_id" v-html="item.product_name" style="line-height: 1.2em"></router-link></div>
                </div>
            </div>

            <!--
            <div class="form-line" v-if="item.type=='physical'">
                <div class="form-field" style="width: 100%">
                    <label>Gift Price</label>
                    <div class="form-static-field">{{ item.price_ex_vat | toCurrency}} <span style="font-size: 14px; font-weight: 100;">({{ item.price | toCurrency }} inc. VAT)</span></div>
                </div>
            </div>
            -->

            <div class="form-line" v-if="item.type=='physical'">
                <div class="form-field" style="width: 100%">
                    <label>Availability</label>
                    <div class="form-static-field"><b>{{ item.available }}</b> units available</div>
                </div>
            </div>

            <div class="form-line" v-if="item.type=='voucher'">
                <div class="form-field" style="width: 50%">
                    <label>Voucher Value</label>
                    <div class="form-static-field">{{ item.voucher_value | toCurrency}}</div>
                    <div v-if="item.pp_ev_cost" style="font-size: 11px; margin-top: -8px;">Admin fee {{ item.pp_ev_cost | toCurrency }} + VAT</div>
                </div>

            </div>

            <div class="form-line" v-if="item.type=='voucher'">
                <div class="form-field" style="width: 50%">
                    <label>Voucher Brand ID</label>
                    <div class="form-static-field"><i>{{ item.voucher_brand }}</i></div>
                </div>

                <div class="form-field" style="width: 50%">
                    <label>Voucher Limit</label>
                    <div class="form-static-field">
                        <i v-if="item.voucher_limit">{{ item.voucher_limit  }} units</i>
                        <i v-else>unlimited use</i>
                    </div>
                </div>
            </div>



            <div class="form-line">
                <div id="form-field-description" class="form-field" style="width: 100%">
                    <label for="form-input-description"><span v-if="item.type=='voucher'">Voucher</span><span v-else>Gift Option</span> Description</label>
                    <textarea v-model="editItem.description" rows="5"></textarea>
                </div>
            </div>
            <div class="form-line" v-if="item.image_url && item.image_url != 'null'">
                <div class="form-field" style="width: 100%">
                    <label><span v-if="item.type=='voucher'">Voucher</span><span v-else>Gift Option</span> Image</label>
                    <img :src="item.image_url" :class="'gift-option-image gift-option-image-'+item.type" alt="Option image">
                </div>
            </div>


            <div class="form-line" v-if="item.type=='physical'">
                <div class="form-field" style="width: 100%">
                    <label>Shipping and Pick & Pack Pricing</label>
                    <table class="worksends-table inset">
                        <thead>
                        <tr>
                            <th style="width: 50%">Countries</th>
                            <th>Exc. VAT</th>
                            <th>Inc. VAT</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="row in shippingCosts">
                            <td>{{ row.countries.join(', ') }}</td>
                            <td>{{ row.shipping_ev_cost | toCurrency}}</td>
                            <td>{{ row.shipping_iv_cost | toCurrency}}</td>
                        </tr>
                        <tr>
                            <td><i>Pick & Pack (all countries)</i></td>
                            <td>{{ item.pp_ev_cost | toCurrency }}</td>
                            <td>{{ item.pp_iv_cost | toCurrency }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>



        <div class="form-actions">
            <span class="ws-button ws-button-secondary" data-action="cancel" @click="close">GO BACK</span>
            <span class="ws-button ws-button-main" @click="save">{{ type === 'edit' ? 'UPDATE' : 'CREATE'}}</span>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "GiftBoxCampaignsOptionModal",
    components: {Modal},
    props: {
        optionId: Number,
        fetchItem: Boolean,
        type: {type: String, default: 'create'},
    },
    data() {
        return {
            newItem: {
                product_id: null
            },
            editItem: {
                description:''
            }
        }
    },
    methods: {
        async save() {
            if (!this.demoCheck()) return;
            
            if (this.type === 'edit') {
                await this.dispatchWaitAndNotify('updateGiftBoxCampaignOption', {optionId: this.optionId, payload: {description: this.editItem.description}}, false, false);
                this.$emit('updated');
            }
        },
        close() {
            if (this.type === 'create') {
                this.modals.giftBoxCampaignsOptionCreate = false
            } else if (this.type === 'edit') {
                this.modals.giftBoxCampaignsOptionEdit = false
            }
        }
    },
    async mounted() {
        if (this.fetchItem) {
            await this.dispatchWaitAndNotify('fetchGiftBoxOption', {optionId: this.optionId}, false, true);
            if (this.type === 'edit') {
                this.editItem.description = this.item.description;
            }
        }
    },
    computed: {
        item() {
            return this.$store.state.giftBoxCampaign.optionDetail;
        },
        modals() {
            return this.$store.state.modals;
        },
        shippingCosts() {
            if (!this.item.shipping_costs) return [];
            return Object.keys(this.item.shipping_costs).map(x => Object.assign({}, this.item.shipping_costs[x])).filter(x => Array.isArray(x.countries));
        }
    }
}
</script>

<style scoped>

</style>
